export const response = {
    responsive: [
        {
            breakpoint: 0,
            settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 530,
            settings: {
                slidesToShow: 2.5,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 2.5,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 953,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                itemWidth: 230,
            },
        },
    ],
}
